import React from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";
import logo from "../../assets/logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10">
          {/* Company Info */}
          <div className="text-center sm:text-left">
            <div className="flex flex-col sm:flex-row items-center sm:items-start space-y-3 sm:space-y-0 sm:space-x-3 mb-4">
              <img src={logo} alt="Shiv Shakti" className="h-12 w-auto" />
              <div>
                <span className="text-lg font-bold text-[#2F3C7E] block">
                  Shiv Shakti
                </span>
                <span className="text-xs text-[#E6B325] tracking-wider">
                  HOSPITALITY
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-4 max-w-sm mx-auto sm:mx-0">
              "Quality, Punctuality, and Hygiene" – Leading facility services
              provider to corporate, institutes and healthcare sector across PAN
              India.
            </p>
            {/*<div className="flex justify-center sm:justify-start space-x-3">
              <a
                href="#"
                className="text-gray-500 hover:text-[#E6B325] transition"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="text-gray-500 hover:text-[#E6B325] transition"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="text-gray-500 hover:text-[#E6B325] transition"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="text-gray-500 hover:text-[#E6B325] transition"
              >
                <Twitter size={20} />
              </a>
            </div>*/}
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold text-[#2F3C7E] mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/clients"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Clients
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold text-[#2F3C7E] mb-4">
              Our Services
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/services"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Industrial Catering
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Corporate Guest House
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Housekeeping & Laundry
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-600 hover:text-[#E6B325] transition text-sm sm:text-base"
                >
                  Restaurant Management
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-semibold text-[#2F3C7E] mb-4">
              Contact Info
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center justify-center sm:justify-start space-x-3 text-gray-600">
                <Phone size={18} className="text-[#E6B325] flex-shrink-0" />
                <span className="text-sm sm:text-base">+91 6377733291</span>
              </li>
              <li className="flex items-center justify-center sm:justify-start space-x-3 text-gray-600">
                <Mail size={18} className="text-[#E6B325] flex-shrink-0" />
                <span className="text-sm sm:text-base break-all">
                  info@shivshaktihospitality.com
                </span>
              </li>
              <li className="flex items-start justify-center sm:justify-start space-x-3 text-gray-600">
                <MapPin
                  size={18}
                  className="text-[#E6B325] flex-shrink-0 mt-1"
                />
                <p className="text-sm sm:text-base">
                  Krishna Restaurant Dharampur Road
                  <br />
                  Atak Pardi, Valsad - 396007
                  <br />
                  (Beside Keshav Kunj, Near Atakpardi)
                </p>
              </li>
              {/*<li className="flex items-center justify-center sm:justify-start space-x-3 text-gray-600">
                <Clock size={18} className="text-[#E6B325] flex-shrink-0" />
                <span className="text-sm sm:text-base">
                  24/7 Service Available
                </span>
              </li>*/}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 py-4">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm text-gray-500 gap-2">
            <p>
            &copy; {currentYear} <a href="https://100billiontech.com/" className="text-[#E6B325] hover:opacity-80 transition"  target="_blank" rel="noopener noreferrer">100billion Tech</a> | All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};   

export default Footer;
